<template>

	<div class="main-contents">
        <div class="mem_container">
            <div class="mem_info_contents">
                <div class="mem_contents_header">
                    <div class="title-txt">마이페이지<br/>
                        <p><span class="prj_ct"><nbsp n="1"/><span>{{data.project.mberNm}}</span> 님 반갑습니다.</span></p><p class="pf_service"><span>[ <SelectComp type="text" list="N:무료,Y:유료" v-model="data.project.contractYn"/> 서비스 회원 ]</span> 이십니다.</p>
                    </div>
                </div>
                <div class="contents-body tab point dco">
                    <div class="my-resume">
                        <div class="photo">
                            <file-select type="image" v-model="corpImg" :src="data.project.imgSrc" defaultSrc="COMPANY" :name="data.project.corpNm"/>
                            <div class="prj_enroll"></div>
                            <div class="intesrt_mem" @click="$router.push({name: 'PRF301M01'})">관심 IT프로 : <span>{{data.project.interestCnt | number}}</span> &#9654; </div>
                            <div class="info_change" @click="$router.push({name: 'MYP302M01'})">
                                <img class="info_change" src="/images/info_change.png" alt="정보수정"/>
                            </div>
                        </div>
                        <!-- <div class="mem-box"></div> -->
                        <div class="mem-box last">
                            <div class="tit">프로젝트 관리 현황</div>
                            <div class="mem-count">
                                <div class="mem">프로젝트 지원 IT프로</div>
                                <div class="count">{{data.project.projectApplyCnt | number}}명</div>
                                <span class="noti" v-if="data.project.projectApplyCnt > 0">!</span>
                                <div class="shortcut" @click="$router.push({name: 'PRJ305M01'})">바로가기 &#9654;</div>
                            </div>
                            <div class="mem-count">
                                <div class="mem">수행예정 프로젝트</div>
                                <div class="count">{{data.project.projectBeforeCnt | number}}건</div>
                                <div class="shortcut" @click="$router.push({name: 'PRJ302M02'})">바로가기 &#9654;</div>
                            </div>
                            <div class="mem-count">
                                <div class="mem">수행중인 프로젝트</div>
                                <div class="count">{{data.project.projectNowCnt | number}}건</div>
                                <div class="shortcut" @click="$router.push({name: 'PRJ302M01'})">바로가기 &#9654;</div>
                            </div>
                            <div class="mem-count">
                                <div class="mem">완료 프로젝트</div>
                                <div class="count">{{data.project.projectEndCnt | number}}건</div>
                                <div class="shortcut" @click="$router.push({name: 'PRJ302M03'})">바로가기 &#9654;</div>
                            </div>
                            <div class="mem-count">
                                <div class="mem">미평가 IT프로</div>
                                <div class="count">{{data.project.evalNeedCnt | number}}명</div>
                                <span class="noti" v-if="data.project.evalNeedCnt > 0">!</span>
                                <div class="shortcut" @click="$router.push({name: 'PRJ302M03'})">바로가기 &#9654;</div>
                            </div>
                        </div>
                        <div class="point-box">
                            <img src="/images/point_ico.png" alt="적립포인트"/> 적립 포인트
                            <span class="point">{{data.project.pointSum | number}}</span>
                            <div class="point-history" @click="$router.push({name: 'PIT301M01'})">적립내역 &#9654;</div>
                        </div>
                    </div>
                </div>
                <!-- 프로젝트 인터뷰 요청 상태 -->
                <div class="contents-body prj dco">
                    <div class="title">인터뷰 요청 상태</div>
                    <!-- 1set -->
                    <template v-if="list && list.length > 0">
                        <template v-for="(item, idx) in list">
                            <hr v-if="idx != 0" :key="'hr_' + idx"/>
                            <div class="prj-box" :key="'project_' + idx">{{item.projectNm}}</div>
                            <div class="member" :key="'total_' + idx">
                                <p>인터뷰 요청 IT프로</p>
                                <span class="count">총 {{item.interviewTotalCnt | number}}명</span>
                            </div>
                            <div class="member" :key="'detail_' + idx">
                                <p>인터뷰 예정</p>
                                <span class="count">{{item.interview01Cnt + item.interview02Cnt | number}}명</span>
                                / 
                                <p>인터뷰 합격</p>
                                <span class="count">{{item.interview04Cnt | number}}명</span>
                                / 
                                <p>인터뷰 불합격</p>
                                <span class="count">{{item.interview03Cnt | number}}명</span>
                                <div class="shortcut" @click="movePage(item)">바로가기 &#9654;</div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="prj-box">인터뷰 중인 프로젝트가 없습니다.</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";

export default {

	data() {
		return {
			data: {},
            list: [],
            corpImg : '',
		};
	},
    components : {
	    fileSelect
	},

    watch : {
		corpImg : function() { this.corpImgAttach(); },
	},
    
	mounted(){
		this.myPage();
	},
	methods: {
        myPage() {
            this.$.httpPost('/api/mem/myp/getDcoPmgPage')
			.then(res => {
				this.data = res.data;
				this.data.project.imgSrc = '/api/mem/myp/corpImageDown?corpSeq=' + this.data.project.corpSeq;
			});
		this.$.httpPost('/api/prj/prj/getInterviewProject')
			.then(res => {
				this.list = res.data.list;
                //console.log(this.list)
			});
        },
        movePage(item) {
            var params = {

				projectSeq : item.projectSeq,
				projectNm : item.projectNm,

				caller : {
					name: this.$route.name,
				}
			}
			this.$router.push({name: 'PRJ306M02', params });
        },

        // 기업 이미지 첨부
		corpImgAttach() {
			if(this.corpImg) {
				this.$.fileUpload('IMG', this.corpImg, '/api/mem/myp/corpImageAttachment', this.data.project)
					.then(res => {
						if(res.statusText == 'OK') {
							this.myPage();
						}
					})
					.catch(err => {
						// console.log('============================='); 
						// console.log(err);
						// console.log(err.response);
						// console.log('============================='); 

						alert(err.response.data.error_description);
					})
			}
		},
	},
};
</script>